import React, { createContext } from 'react'
import { useState, useCallback, useEffect, useMemo } from 'sb-hooks'
import PropTypes from 'prop-types'


export const RadioGroupContext = createContext()

const RadioGroup = ({ children, className, field, dataTestId, onChange, ariaLabel, ariaLabelledBy }) => {
  const [ value, setValue ] = useState(field.value)

  const handleChange = useCallback((event) => {
    const { value } = event.target

    field.set(value)

  }, [ field ])

  useEffect(() => {
    const handleFieldChange = (newValue) => {
      setValue(newValue)

      if (typeof onChange === 'function') {
        onChange(newValue)
      }
    }

    field.on('change', handleFieldChange)

    return () => {
      field.off('change', handleFieldChange)
    }
  }, [ field, setValue, onChange ])

  const context = useMemo(() => ({
    name: field.name,
    activeValue: value,
    onChange: handleChange,
  }), [ field.name, value, handleChange ])

  return (
    <RadioGroupContext.Provider value={context}>
      <div
        className={className}
        data-testid={dataTestId}
        role="radiogroup"
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
      >
        {children}
      </div>
    </RadioGroupContext.Provider>
  )
}

RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  field: PropTypes.object.isRequired,
  dataTestId: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  onChange: PropTypes.func,
}


export default RadioGroup
